<div class="dx-card wide-card">
    <div class="btndiv">
        <dx-button icon="export" text="Export Charts" type="default" class="exportbtn" (onClick)="exportCharts()">
        </dx-button>
    </div>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>

            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>

            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <h5 style="text-align: center;">CURRENT ANALYSIS:</h5>
                <h5 style="text-align: center;">Tonnage Business Announcement Capital</h5>
                <b style="text-align: center;">CY{{selectedAnnouncementYear}}
                    {{currentYearMonthsInfo}}
                </b>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <h5 style="text-align: center;">PREVIOUS ANALYSIS:</h5>
                <h5 style="text-align: center;">Tonnage Business Announcement Capital</h5>
                <b style="text-align: center;">CY{{selectedAnnouncementYear - 1}}
                </b>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="1" [col]="0"></dxi-location>
                <h6 style="text-align: center;">{{cyTBCBillionUSDCapital}} </h6>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="1" [col]="1"></dxi-location>
                <h6 style="text-align: center;">{{pyTBCBillionUSDCapital}} </h6>
            </dxi-item>

            <dxi-item>
                <dxi-location [row]="2" [col]="0"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" class="width100" palette="soft"
                        #currentYearTonnageBusinessCapitalReportChart id="currentYearTonnageBusinessCapitalReportChart"
                        [dataSource]="cyTonnageBusinessCapitalDataSource">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis position="center">
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="true" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="2" [col]="1"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" class="width100" palette="soft"
                        #previousYearTonnageBusinessCapitalReportChart
                        id="previousYearTonnageBusinessCapitalReportChart"
                        [dataSource]="pyTonnageBusinessCapitalDataSource">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis position="center">
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="true" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>

            <dxi-item class="marginL30 marginT15">
                <dxi-location [row]="3" [col]="0"></dxi-location>
                <h5 style="text-align: center;">ASU Capital Only </h5>
            </dxi-item>
            <dxi-item class="marginL30 marginT15">
                <dxi-location [row]="3" [col]="1"></dxi-location>
                <h5 style="text-align: center;">ASU Capital Only</h5>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="4" [col]="0"></dxi-location>
                <h6 style="text-align: center;">{{cyASUCBillionUSDCapital}} </h6>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="4" [col]="1"></dxi-location>
                <h6 style="text-align: center;">{{pyASUCBillionUSDCapital}} </h6>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="0"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" palette="soft" class="width100"
                        #currentYearAnalysisASUReportChart id="currentYearAnalysisASUReportChart"
                        [dataSource]="cyASUCapitalDataSource">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis>
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="1"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" class="width100" palette="soft"
                        #previousYearAnalysisASUReportChart id="previousYearAnalysisASUReportChart"
                        [dataSource]="pyASUCapitalDataSource">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis position="center">
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>

            <dxi-item class="marginL30 marginT15">
                <dxi-location [row]="6" [col]="0"></dxi-location>
                <h5 style="text-align: center;">HyCO Capital Only </h5>
            </dxi-item>
            <dxi-item class="marginL30 marginT15">
                <dxi-location [row]="6" [col]="1"></dxi-location>
                <h5 style="text-align: center;">HyCO Capital Only</h5>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="7" [col]="0"></dxi-location>
                <h6 style="text-align: center;">{{cyHyCOCBillionUSDCapital}} </h6>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="7" [col]="1"></dxi-location>
                <h6 style="text-align: center;">{{pyHyCOCBillionUSDCapital}} </h6>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="8" [col]="0"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" palette="soft" class="width100"
                        #currentYearAnalysisHyCoReportChart id="currentYearAnalysisHyCoReportChart"
                        [dataSource]="cyHyCOCapitalDataSource">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis position="center">
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="8" [col]="1"></dxi-location>
                <div>
                    <dx-chart [customizePoint]="customizePoint" palette="soft" class="width100"
                        #previousYearAnalysisHyCoReportChart id="previousYearAnalysisHyCoReportChart"
                        [dataSource]="pyHyCOCapitalDataSource">
                        <dxo-common-series-settings argumentField="competitor" valueField="competitorInvestment"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Capital USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-argument-axis position="center">
                            <dxo-title text="Competitor"></dxo-title>
                        </dxo-argument-axis>
                        <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-series-template nameField="businessType"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="9" [col]="0" [colspan]="2"></dxi-location>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Grids" type="default" class="exportgridbtn"
                        (onClick)="exportExcel($event)">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item class="marginB10 grdmaxwidth">
                <dxi-location [row]="10" [col]="0"></dxi-location>
                <dx-pivot-grid #cyPivotGrid id="cyPivotGrid" [allowSortingBySummary]="true" [allowFiltering]="false"
                    (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [showColumnGrandTotals]="true"
                    [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                    [dataSource]="cyPivotGridDataSource">
                    <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-field-panel [showDataFields]="false" [showRowFields]="true" [showColumnFields]="false"
                        [showFilterFields]="false" [allowFieldDragging]="false" [visible]="true">
                    </dxo-field-panel>
                </dx-pivot-grid>
            </dxi-item>
            <dxi-item class="marginB10 marginL5 grdmaxwidth">
                <dxi-location [row]="10" [col]="1"></dxi-location>
                <dx-pivot-grid #pyPivotGrid id="pyPivotGrid" [allowSortingBySummary]="true" [allowFiltering]="false"
                    (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [showColumnGrandTotals]="true"
                    [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                    [dataSource]="pyPivotGridDataSource">
                    <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-field-panel [showDataFields]="false" [showRowFields]="true" [showColumnFields]="false"
                        [showFilterFields]="false" [allowFieldDragging]="false" [visible]="true">
                    </dxo-field-panel>
                </dx-pivot-grid>
            </dxi-item>
        </dx-responsive-box>
    </div>
</div>